import { render, staticRenderFns } from "./ColumnBlock.vue?vue&type=template&id=7a8109ba&scoped=true"
import script from "./ColumnBlock.vue?vue&type=script&lang=js"
export * from "./ColumnBlock.vue?vue&type=script&lang=js"
import style0 from "./ColumnBlock.vue?vue&type=style&index=0&id=7a8109ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8109ba",
  null
  
)

export default component.exports